<div class="logo" role="img" aria-label="Rymax"></div>
<div class="text">
    <p class="section-heading">We’re working quickly to restore service.</p>
    <p class="body-0">Sorry, we ran into a problem and are working to restore service. Please check back later.</p>
</div>
<div class="action-button">
    <button mat-raised-button class="proceed-to-payment-btn" type="button" (click)="onGoToMainPage()">
        Go back to main page
    </button>
</div>
